import { Component, ElementRef, ViewChild } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { GraphqlService } from 'src/app/graphql/graphql.service';
import { environment } from 'src/environments/environment';
import { FeatureTour } from '../../models';
import { AbstractPageForm } from '../../pages/page-form.abstract';

@Component({
	selector: 'pk-broker-feature-tour-modal',
	templateUrl: './feature-tour-modal.component.html',
	styleUrls: ['./feature-tour-modal.component.scss'],
	standalone: false,
})
export class FeatureTourModalComponent extends AbstractPageForm {
	@ViewChild('videoPlayer') videoplayer: ElementRef;

	// input option 1
	public featureTour: Subset<FeatureTour>;
	// input option 2
	public featureTourLocationId: number; //If you want to load tour "on-command"

	public environment = environment;

	public activeIndex = 0;
	public loading = true;

	constructor(
		private activeModal: BsModalRef,
		private graphqlService: GraphqlService,
	) {
		super();
	}

	public async loadPageData(): Promise<void> {
		if (this.featureTourLocationId) {
			const result = await this.graphqlService.getFeatureTourLocation(this.featureTourLocationId);
			this.featureTour = new FeatureTour(result.data.featureTourLocation?.featureTour);
		}
	}

	public close(): void {
		this.activeModal.hide();
	}

	public next(): void {
		this.videoplayer?.nativeElement.pause();
		this.activeIndex++;
		if (this.activeIndex >= this.featureTour.slides.length) {
			this.activeIndex = 0;
		}
	}

	public previous(): void {
		this.videoplayer?.nativeElement.pause();
		this.activeIndex--;
		if (this.activeIndex < 0) {
			this.activeIndex = this.featureTour.slides.length - 1;
		}
	}
}
